module.exports = __webpack_public_path__ + "img/partner.6a343807.svg";